import { render } from "./bancos.vue?vue&type=template&id=26ec03a0"
import script from "./bancos.vue?vue&type=script&lang=js"
export * from "./bancos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__